import React from "react";
import SecondaryButton from "../Components/SecondaryButton";
import PrimaryButton from "../Components/PrimaryButton";
import { useSelector } from 'react-redux';
import ReactCodeInput from 'react-code-input';
import TextButton from "../Components/TextButton";
import { useNavigate } from "react-router-dom";
import { getContent } from "../content";

const props = {
  inputStyle: {
    margin: '4px',
    MozAppearance: 'textfield',
    width: '38px',
    borderRadius: '8px',
    fontSize: '18px',
    height: '45px',
    color: 'black',
    padding: '0px',
    textAlign: 'center',
    border: '2px solid #0D326A',
    fontFamily: 'Roboto-Black',
    WebkitAppearance: 'none',
  },
  inputStyleInvalid: {
    margin: '4px',
    MozAppearance: 'textfield',
    width: '36px',
    borderRadius: '8px', fontSize: '18px',

    height: '36px',
    color: 'black',
    textAlign: 'center',
    fontFamily: 'Roboto-Black',
    border: '2px solid rgb(239, 68, 68)',
    WebkitAppearance: 'none',

  }
}

function LastFourEntryForm({ submit, submitText, cancel }) {
  const registrant = useSelector((state) => state.registrant);
  const [key, setKey] = React.useState(Math.random());
  const [lastFour, setLostFour] = React.useState('');
  const [showError, setShowError] = React.useState(false);
  let navigate = useNavigate();

  React.useEffect(() => {
    const {
      last_four_ssn,
    } = registrant;

    setKey(Math.random());
    setLostFour(last_four_ssn)
  }, []);

  const handleSubmit = event => {
    event.preventDefault();
    if ((registrant.id_type === 'have_ssn' && lastFour.length < 4) || lastFour === '0000') {
      setShowError(true);
    } else {
      setShowError(false);
      submit({ last_four_ssn: lastFour })
    }
  };

  return (
    <>
      <form onSubmit={handleSubmit}>
        <div className="flex items-center justify-center mt-6 mb-4">
          <span className="text-3xl tracking-wider black font-RobotoBlack">XXX-XX-</span>
          <ReactCodeInput type='number' fields={4} value={lastFour} key={key} onChange={(value) => {
            if (value.length > 0 && value.length < 4) {
              setShowError(true);
            } else {
              setShowError(false);
            }
            setLostFour(value);
          }} {...props} />
        </div>
        {showError && <span className="text-center error">{getContent('fields.last_four')}</span>}
        <div className="flex justify-end pt-8 pb-2">
          {!submitText && registrant?.id_type !== 'have_ssn' &&
            <TextButton onClick={() => {
              if (registrant?.id_type === 'have_ssn') {
                navigate('/not-eligible');
              } else {
                navigate('/party-affiliation');
              }
            }}>{getContent('buttons.no_ssn')}</TextButton>
          }
          {submitText && (
            <TextButton onClick={cancel} className="pr-2">{getContent('buttons.cancel')}</TextButton>
          )}
          <PrimaryButton submit className="ml-6">{!submitText ? getContent('buttons.next_step') : submitText}</PrimaryButton>
        </div>
      </form>
    </>
  );
}

export default LastFourEntryForm;